import { render, staticRenderFns } from "./ModalCreateProject.vue?vue&type=template&id=9f247636&scoped=true&"
import script from "./ModalCreateProject.vue?vue&type=script&lang=js&"
export * from "./ModalCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateProject.vue?vue&type=style&index=0&id=9f247636&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f247636",
  null
  
)

export default component.exports